import React, { Component } from 'react';

class Step2 extends Component {
    render() {
        return (
            <div className="card card-body">
                <div className="form-group">
                    <label htmlFor="systemDescription">Monitoring System Description</label>
                    <div>
                        <select id="systemDescription" name="systemDescription" className="custom-select" required="required">
                            <option value="Fire Alarm System">FIRE ALARM SYSTEM</option>
                            <option value="Sprinkler System - Alarm and Supervisory Devices">SPRINKLER SYSTEM - ALARM AND SUPERVISORY DEVICES</option>
                            <option value="Other">OTHER</option>
                        </select>
                    </div>
                </div>
                {/* TODO systemManufacturerName */}
                <div className="form-group">
                    <label htmlFor="systemManufacturerName">Fire Alarm System Manufacturer & Model No:</label>
                    <input id="systemManufacturerName" name="systemManufacturerName" type="text" required="required" className="form-control here" />
                </div>
                {/* TODO manufacturerName */}
                <div className="form-group">
                    <label htmlFor="manufacturerName">Alarm Signal Transmitter Manufacturer</label>
                    <input id="manufacturerName" name="manufacturerName" type="text" required="required" className="form-control here" />
                </div>
                <div className="form-group">
                    <label htmlFor="modelNumber">Model Number</label>
                    <input id="modelNumber" name="modelNumber" type="text" required="required" className="form-control here" />
                </div>
                <div className="form-group">
                    <label htmlFor="equipmentListing">Equipment Listing Number</label>
                    <input id="equipmentListing" name="equipmentListing" type="text" required="required" className="form-control here" />
                </div>
                {/* TODO equipmentLocation */}
                < div className="form-group" >
                    <label htmlFor="equipmentLocation">Location of the Signal Transmitting Equipment</label>
                    < input id="equipmentLocation" name="equipmentLocation" type="text" required="required" className="form-control here" />
                </div>
                <div className="form-group">
                    <label htmlFor="centreName">Fire Signal Receiving Centre</label>
                    <input id="centreName" name="centreName" type="text" required="required" className="form-control here" value="Graham Alarm Monitoring Ltd." />
                </div>
                <div className="form-group">
                    <label htmlFor="centreAccount">Fire Signal Receiving Centre Identification (System Account #):</label>
                    <input id="centreAccount" name="centreAccount" type="text" required="required" className="form-control here" />
                </div>
                <div className="form-group">
                    <label htmlFor="centrePhone">Monitoring Station Telephone Number:</label>
                    <input id="centrePhone" name="centrePhone" type="text" required="required" className="form-control here" value="905-897-8822" />
                </div>
                {/* TODO dealerName */}
                < div className="form-group" >
                    <label htmlFor="dealerName">Installing and Servicing Dealer Name</label>
                    < input id="dealerName" name="dealerName" type="text" required="required" className="form-control here" />
                </div>
                {/* TODO dealerPhone */}
                < div className="form-group" >
                    <label htmlFor="dealerPhone">Installing and Servicing Dealer Phone</label>
                    < input id="dealerPhone" name="dealerPhone" type="text" required="required" className="form-control here" />
                </div>
            </div>
        )
    }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/components/Step2.js